/**
 * EventView view component.
 * @module components/theme/View/EventView
 */

import { defineMessages, useIntl } from 'react-intl';
import { Grid } from 'semantic-ui-react';
import { hasBlocksData, flattenToAppURL, BodyClass } from '@plone/volto/helpers';
import { EventDetails, Image } from '@plone/volto/components';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/free-regular-svg-icons';
import { getDayName, getMonthName } from '../../helpers'
import { Attachments, ShareBar } from '../';

const messages = defineMessages({
  downloadEvent: {
    id: 'Download Event',
    defaultMessage: 'Download Event',
  }
})


const EventDateTime = ({ start, end }) => {

  const getDateDay = function (dateStr) {
    const date = new Date(dateStr);
    return date.getDate()
  }

  const getDateDayName = function (dateStr) {
    const date = new Date(dateStr);
    return getDayName(date)
  }

  const getDateMonthName = function (dateStr) {
    const date = new Date(dateStr);
    return getMonthName(date)
  }

  const getHour = function (dateStr) {
    const date = new Date(dateStr);

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  const isSameDay = function (start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    return (
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getDate() === endDate.getDate()
    );
  }

  return (
    <>
      {isSameDay(start, end) ? (
        <>
          <time className="eventView__date " dateTime={start}>
            <div className='eventView__date__day'>
              <span className="weekdayName">{getDateDayName(start)}</span>
              <span className="weekday">{getDateDay(start)}</span>
              <span className="monthName">{getDateMonthName(start)}</span>
            </div>
            <span className="eventView__date__time">
              <span>{getHour(start)}</span>
              <span>{getHour(end)}</span>
            </span>
          </time>
        </>
      ) : (
        <div className='d-flex gap-3'>
          <time className="eventView__date" dateTime={start}>
            <div className='eventView__date__day eventView__date__day--hasEnd'>
              <span className="weekdayName">{getDateDayName(start)}</span>
              <span className="weekday">{getDateDay(start)}</span>
              <span className="monthName">{getDateMonthName(start)}</span>
            </div>
            <span className="eventView__date__time">
              <span>{getHour(start)}</span>
            </span>
          </time>
          <time className="eventView__date " dateTime={end}>
            <div className='eventView__date__day eventView__date__day--hasEnd'>
              <span className="weekdayName">{getDateDayName(end)}</span>
              <span className="weekday">{getDateDay(end)}</span>
              <span className="monthName">{getDateMonthName(end)}</span>
            </div>
            <span className="eventView__date__time">
              <span>{getHour(end)}</span>
            </span>
          </time>
        </div>
      )}
    </>
  );
};


const EventView = (props) => {
  const { content } = props;
  const intl = useIntl();

  return (
    <>
      <BodyClass className='smallHeader' />
      <div id="page-document" className="view-wrapper eventView">

        <Grid>

          <Grid.Column className="blocksColumn" mobile={12} tablet={12} computer={content.preview_image ? 8 : 12}>
            <div className="pageBlocks mb-5">
              {hasBlocksData(content) && (
                <RenderBlocks {...props} />
              )}
            </div>

            <div className='px-4 pt-4 pb-1 border border-gray-bg'> 
              <EventDetails content={content} />
            </div>
          </Grid.Column>

          {content.preview_image && (
            <Grid.Column mobile={12} tablet={12} computer={4}>
              <figure className="m-0 eventView__figure">
                <Image className="w-100 h-auto d-block"
                  alt=""
                  item={content}
                  imageField="preview_image"
                  responsive={true}
                  sizes="(max-width: 767px) 100vw, (max-width: 991px) 50vw, 20vw"
                />
                {content.preview_caption && (
                  <figcaption className='eventView__caption'>{content.preview_caption}</figcaption>
                )}
              </figure>
              <p className="mt-4 pt-2 text-start pb-3">
                <a className="ics-download ui button inverted primary"
                  target="_blank"
                  rel="noreferrer"
                  href={`${flattenToAppURL(content['@id'])}/ics_view`}
                >
                  <FontAwesomeIcon icon={faCalendarPlus} className="readMoreItem__icon me-3" />
                  {intl.formatMessage(messages.downloadEvent)}
                </a>
              </p>
            </Grid.Column>
          )}
        </Grid>

       

        <Attachments {...content} />
        <ShareBar />
      </div>
    </>
  );
};


export default EventView;
